import fetchDependencies from "./helpers/fetch-dependencies"

export async function init() {
  const { Vue, VueI18n, data } = await fetchDependencies()
  const { default: signup } = await import(/* webpackChunkName: 'sign-up' */ "./signup")
  signup(Vue, VueI18n, data)
}

const { FCGON } = window

export function showSignup() {
  if (FCGON.is_app) {
    const { callNativeApp } = window
    if (callNativeApp) {
      callNativeApp("subscribe")
      return
    }
  }
  init()
}

window.showSignup = showSignup

export default async function setListeners() {
  const nodes = Array.from(document.querySelectorAll(".js-sign-up, .js-sign-up-no-free"))
  nodes.forEach((node) => {
    node.addEventListener("click", (event) => {
      event.preventDefault()
      showSignup()
    })
  })
  // Automatic startup on the dedicated sign up page
  if (FCGON && FCGON.sign_up_immediately) {
    init()
  }
}
